// i18next support structure

export default {
  en: {
    translation: require('./en/translation.json')
  },
  ru: {
    translation: require('./ru/translation.json')
  }
}
